import { default as deDE } from 'locales/deDE.json';

export type TranslationKey = keyof typeof deDE;

export type TransParams = {
  weekNumber?: number;
  hours?: string;
  /** Guest form runner: "Question {current} of {total}" and the free-text counter. */
  current?: number;
  total?: number;
  remaining?: number;
  /** text_area's soft budget — guidance while typing, distinct from the hard maximum. */
  budget?: number;
  /** multi_select: how many options are chosen, and the limits or advice around that count. */
  count?: number;
  min?: number;
  max?: number;
  /** date_picker: the window's bounds, already formatted for the respondent's locale. */
  from?: string;
  to?: string;
  /** item_scale: how many of the items carry a level, against how many there are. */
  done?: number;
};

export enum AppLocale {
  en_US = 'en-US',
  de_DE = 'de-DE'
}
